import { render, staticRenderFns } from "./FolderDragIcon.vue?vue&type=template&id=25593ccf"
import script from "./FolderDragIcon.vue?vue&type=script&lang=js"
export * from "./FolderDragIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports